import type { MarketingMegaLink } from "~/lib/marketplace/marketing-nav-config";
import {
  AUDIT_AEO_HREF,
  AUDIT_ARO_HREF,
  AUDIT_CRO_HREF,
  AUDIT_INDEX_HREF,
  BENCHMARK_LIBRARY_HREF,
  WORDPRESS_PLUGIN_HREF,
} from "~/lib/siteglue/landing-redesign/copy";

/** Header dropdown + /resources index. Reuses existing routes. No primary-nav duplicates. */
export const SITEGLUE_RESOURCES_LINKS: MarketingMegaLink[] = [
  {
    label: "Optimization Audits",
    href: AUDIT_INDEX_HREF,
    description: "ARO, CRO, and AEO — three optimization services around SiteGlue Agent.",
  },
  {
    label: "Audit Benchmark Library",
    href: BENCHMARK_LIBRARY_HREF,
    description: "Searchable checks shared by the scanner, reports, and recommendations.",
  },
  {
    label: "ARO Audit",
    href: AUDIT_ARO_HREF,
    description: "Get discovered and connected. Agent Readiness Optimization.",
  },
  {
    label: "CRO Audit",
    href: AUDIT_CRO_HREF,
    description: "Convert more visitors into customers across forms and channels.",
  },
  {
    label: "AEO Audit",
    href: AUDIT_AEO_HREF,
    description: "Get recommended. Answer Engine Optimization.",
  },
  {
    label: "WordPress Plugin",
    href: WORDPRESS_PLUGIN_HREF,
    description: "Supported ARO improvements for WordPress sites. No admin passwords in chat.",
  },
  {
    label: "Documentation",
    href: "/documentation",
    description: "Setup guides, channels, and integration walkthroughs.",
  },
  {
    label: "Blog",
    href: "/blog",
    description: "Product updates, playbooks, and industry tips.",
  },
  {
    label: "Announcements",
    href: "/announcements",
    description: "Release notes and product announcements.",
  },
  {
    label: "Help Center",
    href: "/help-center",
    description: "Answers for common questions and troubleshooting.",
  },
  {
    label: "API Reference",
    href: "/api-reference",
    description: "Webhooks, authentication, and developer resources.",
  },
  {
    label: "AI Summary",
    href: "/ai-summary",
    description: "Machine-readable overview for AI systems and researchers.",
  },
];
